<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig"
  (filterChange)="onFilter($event)"
></aur-mat-table>

